webpackJsonp([208176855801404],{

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  border-top: 1px solid ', ';\n  padding-top: 1.5rem;\n  margin-bottom: 1.5rem;\n  color: ', ';\n  font-size: 1.125rem;\n  font-style: italic;\n\n  > cite {\n    margin-top: 0.75rem;\n    color: ', ';\n    font-size: 1rem;\n    font-style: normal;\n    font-family: ', ';\n  }\n'], ['\n  border-top: 1px solid ', ';\n  padding-top: 1.5rem;\n  margin-bottom: 1.5rem;\n  color: ', ';\n  font-size: 1.125rem;\n  font-style: italic;\n\n  > cite {\n    margin-top: 0.75rem;\n    color: ', ';\n    font-size: 1rem;\n    font-style: normal;\n    font-family: ', ';\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(23);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(15);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _message = __webpack_require__(59);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _page = __webpack_require__(24);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _theme = __webpack_require__(16);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Blockquote = _styledComponents2.default.blockquote(_templateObject, _theme2.default.colors.lightTeal, _theme2.default.colors.darkTeal, _theme2.default.colors.muted, _theme2.default.fonts.sans);
	
	var Testimonials = function Testimonials(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    _page2.default,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Customer Testimonials for ',
	        data.site.siteMetadata.title
	      )
	    ),
	    _react2.default.createElement(
	      'h1',
	      null,
	      'From Our Clients'
	    ),
	    _react2.default.createElement(
	      Blockquote,
	      null,
	      'Thanks, Bob, for yet another great job! Did I see you guys working on Cokie Robert\u2019s house today? Believe it or not, I have another small job to ask you about\u2014putting a very small patio behind our lower school, using the flagstone that you took up. Also, would you give us a trimming lesson (if needed) for the landscaping in front of the upper school? Thanks.',
	      _react2.default.createElement(
	        'cite',
	        null,
	        'Christopher Abell, Mater Dei School, Bethesda, MD'
	      )
	    ),
	    _react2.default.createElement(
	      Blockquote,
	      null,
	      'Bob, thanks so much for your work on our property\u2014you did everything we asked and more. Your rustic touches were exactly what my husband and I were looking for. I can\u2019t believe you were able to capture our ideas so well!',
	      _react2.default.createElement(
	        'cite',
	        null,
	        'Beth Stouffer, Potomac, MD'
	      )
	    ),
	    _react2.default.createElement(
	      Blockquote,
	      null,
	      'Just wanted to write a quick note to thank you all for the fantastic job. The plants you were able to get for us fit the lawn perfectly, and the new patio is fantastic. Thanks again!',
	      _react2.default.createElement(
	        'cite',
	        null,
	        'John, Silver Spring, MD'
	      )
	    ),
	    _react2.default.createElement(
	      _message2.default,
	      null,
	      'Call to schedule a free estimate ',
	      data.site.siteMetadata.phone
	    )
	  );
	};
	
	exports.default = Testimonials;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-testimonials-js-6be6f2e4beb5a58adbcf.js